interface displayOptionsInterface {
  activity: boolean;
  sleep: boolean;
  bloodGlucose: boolean;
  bloodPressure: boolean;
  heartRate: boolean;
  respirationRate: boolean;
  oxygenSaturation: boolean;
  spirometry: boolean;
  temperature: boolean;
  weight: boolean;
  memberNotes: boolean;
}

interface SpirometryVisibilityInterface {
  fev1: boolean;
  fvc: boolean;
  fev1fvc: boolean;
  pef: boolean;
}

export interface brandingOptionsInterface {
  clientLogo: string;
  favicon: string;
}

export interface basicOptionsInterface {
  expirationDate: string;
  units: string;
  glucoseUnits: string;
  supportURL?: string;
  pushURL?: string;
  surveys: boolean;
  cellDevices: boolean;
  smartDevices: boolean;
  emailNotifications: boolean;
  selfRegistration: boolean;
  messaging: boolean;
  notes: boolean;
}

export interface orderingOptionsInterface {
  bulkUploads: boolean;
  newMember: "demo" | "production" | "none";
  customOrder: boolean;
  orderDetails: object | undefined;
  bulkDestination: {
    name?: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    phone?: string;
    email?: string;
  };
  shippingFacility: {
    address: string;
    city: string;
    state: string;
    zip: string;
  };
  pleaseInclude: [
    {
      _id: string;
      email: string;
    }
  ];
}

export interface regOptionsInterface {
  programs: [{ name: string; mdmID: string }];
  groups: [string];
}

export interface globalThreshOptionsInterface {
  systolic: boolean;
  diastolic: boolean;
  glucose: boolean;
  pulse: boolean;
  spo2: boolean;
  FEV1: boolean;
  FVC: boolean;
  FEV1_FVC: boolean;
  PEF: boolean;
  temp: boolean;
  wt: boolean;
  steps: boolean;
  sleep: boolean;
}

export interface configInterface {
  authToken: string;
  pageRender: string;
  coordLogin?: boolean;
  providerLogin?: boolean;
  footerTab: number;
  displayOptions: displayOptionsInterface;
  chartOptions: displayOptionsInterface;
  previewOptions: displayOptionsInterface | any;
  spirometryVisibility: SpirometryVisibilityInterface;
  brandingOptions: brandingOptionsInterface;
  basicOptions: basicOptionsInterface;
  orderOptions: orderingOptionsInterface;
  regOptions: regOptionsInterface;
  globalThreshOptions: globalThreshOptionsInterface;
}


export const configContext: configInterface = {
  pageRender: "home",
  authToken: "",
  footerTab: 0,
  displayOptions: {
    activity: true,
    sleep: true,
    bloodGlucose: true,
    bloodPressure: true,
    heartRate: true,
    respirationRate: false,
    oxygenSaturation: true,
    spirometry: true,
    temperature: true,
    weight: true,
    memberNotes: false
  },
  chartOptions: {
    activity: true,
    sleep: true,
    bloodGlucose: true,
    bloodPressure: true,
    heartRate: true,
    respirationRate: false,
    oxygenSaturation: true,
    spirometry: true,
    temperature: true,
    weight: true,
    memberNotes: false
  },
  previewOptions: {
    activity: true,
    sleep: true,
    bloodGlucose: true,
    bloodPressure: true,
    heartRate: true,
    respirationRate: false,
    oxygenSaturation: true,
    spirometry: true,
    temperature: true,
    weight: true,
    memberNotes: false
  },
  spirometryVisibility: {
    fev1: true,
    fvc: true,
    fev1fvc: true,
    pef: true,
  },
  brandingOptions: {
    clientLogo: "",
    favicon: ""
  },
  basicOptions: {
    expirationDate: "12/01/2030",
    units: "us",
    glucoseUnits: "mg/dL",
    surveys: true,
    cellDevices: true,
    smartDevices: true,
    emailNotifications: true,
    selfRegistration: false,
    messaging: true,
    notes: true
  },
  orderOptions: {
    bulkUploads: true,
    newMember: "demo",
    customOrder: false,
    orderDetails: {},
    bulkDestination: {
      name: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      email: ""
    },
    shippingFacility: {
      address: "",
      city: "",
      state: "",
      zip: ""
    },
    pleaseInclude: [{ _id: "", email: "" }]
  },
  regOptions: {
    programs: [{ name: "test", mdmID: "" }],
    groups: ["test"]
  },
  globalThreshOptions: {
    systolic: true,
    diastolic: true,
    glucose: true,
    pulse: true,
    spo2: true,
    FEV1: true,
    FVC: true,
    FEV1_FVC: true,
    PEF: true,
    temp: true,
    wt: true,
    steps: true,
    sleep: true,
  }
};
